// Auth läuft über ein HttpOnly-Session-Cookie, das der Server bei /api/token
// setzt — JS hat keinen Zugriff auf das Token (XSS-Schutz). Im localStorage
// liegt nur noch ein unkritisches Flag fürs Client-Routing; die eigentliche
// Zugriffskontrolle macht der Server über das Cookie.
const LOGIN_FLAG_KEY = "pzrm_logged_in";
const LEGACY_TOKEN_KEY = "pzrm_auth_token";

// Alt-Token aus früheren Versionen aufräumen (lag im localStorage).
try {
  localStorage.removeItem(LEGACY_TOKEN_KEY);
} catch {
  // ignore
}

export function isLoggedIn(): boolean {
  try {
    return localStorage.getItem(LOGIN_FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

export function markLoggedIn(): void {
  try {
    localStorage.setItem(LOGIN_FLAG_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearLoggedIn(): void {
  try {
    localStorage.removeItem(LOGIN_FLAG_KEY);
  } catch {
    // ignore
  }
}

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, message: string, body: unknown) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

type RequestInitEx = Omit<RequestInit, "body"> & { body?: unknown };

export async function apiFetch<T = unknown>(path: string, init: RequestInitEx = {}): Promise<T> {
  const headers = new Headers(init.headers as HeadersInit | undefined);
  if (init.body !== undefined && !(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const body =
    init.body instanceof FormData || typeof init.body === "string" || init.body === undefined
      ? (init.body as BodyInit | undefined)
      : JSON.stringify(init.body);

  const res = await fetch(path, { ...init, headers, body });
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json().catch(() => null) : await res.text();

  if (res.status === 401) {
    clearLoggedIn();
    if (!path.includes("/api/token")) {
      window.location.assign("/app/login");
    }
  }

  if (!res.ok) {
    const message =
      (isJson && payload && typeof payload === "object" && "detail" in (payload as object)
        ? String((payload as { detail: unknown }).detail)
        : `HTTP ${res.status}`) || `HTTP ${res.status}`;
    throw new ApiError(res.status, message, payload);
  }
  return payload as T;
}
